import type { GroupBase, MenuListProps, MultiValue } from 'react-select';
import { components } from 'react-select';
import Checkbox from '@/app/components/Checkbox';
import type { OptionType } from '../types';

export const SelectAllMenuList = <T extends OptionType>(props: MenuListProps<T, true, GroupBase<T>>) => {
  const { getValue, options, selectProps } = props;

  const selected = getValue();
  const selectableOptions = (options as (T & { isDisabled?: boolean })[]).filter((o) => !o.isDisabled);
  const allSelected = selectableOptions.length > 0 && selected.length === selectableOptions.length;
  const indeterminate = selected.length > 0 && !allSelected;

  const handleToggleAll = () => {
    const newValue: MultiValue<T> = allSelected ? [] : selectableOptions;
    selectProps.onChange(newValue, {
      action: allSelected ? 'deselect-option' : 'select-option',
      option: selectableOptions[0],
    });
  };

  return (
    <components.MenuList {...props}>
      <div className="px-3 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100" onClick={handleToggleAll}>
        <Checkbox checked={allSelected} indeterminate={indeterminate} dashIcon={indeterminate} readOnly />
        <span className="text-body-regular text-black">Select all</span>
      </div>
      {props.children}
    </components.MenuList>
  );
};
